import Modal from "../Modal/Modal";
import React, { useRef, useState } from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";
import { Divider } from "antd";
import FormButton from "../FormCustom2/Button";
import { Form } from "antd";
import FormInput from "../FormCustom2/Input";
import produce from "immer";
import { FormItem } from "../Form";
import {
  errorView,
  updateAddressBook,
} from "../../services/app";
import { CloseIconRounded } from "../Icons/CloseIconMb";
import { isAddress } from "../../utils/helper";
import { error, success } from "../../Notification";
import { useEffect } from "react";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalEdit = (props) => {
  const { T, setLoading, loading } = useApp();
  const { item } = props;
  const [form] = Form.useForm();
  const [available, setAvailable] = useState(false);
  const [showPaste, $showPaste] = useState(true);
  const [errors, setErrors] = useState([]);
  const inputAddressRef = useRef(null);

  useEffect(() => {
    if (item) {
      $showPaste(false);
      form.setFieldsValue({
        address: item.address,
        name: item.name,
      });
    }
  }, [item]);

  const handleOnPaste = () => {
    navigator.clipboard.readText().then((cliptext) => {
      form.setFieldsValue({
        address: cliptext,
      });
      form.validateFields(["address"]);
      onUpdateData();
      setTimeout(() => {
        inputAddressRef.current?.focus({
          cursor: 'end',
        });
      }, 0);
    }).catch((error) => {
      console.error("Failed to read clipboard contents: ", error);
    });
    $showPaste(false);
  };

  useEffect(() => {
    if (props.defaultAddress) {
      form.setFieldsValue({
        address: props.defaultAddress,
      });
      $showPaste(false);
    }
  }, [props.defaultAddress]);

  const handleOnRemove = () => {
    form.setFieldsValue({
      address: "",
    });
    form.validateFields(["address"]);
    onUpdateData();
    $showPaste(true);
  };

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    if (values.address) {
      $showPaste(false);
    } else {
      $showPaste(true);
    }
    setAvailable(
      values.address &&
        isAddress(values.address) &&
        values.name
    );
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const result = await updateAddressBook({
        ...values,
        id: item.id,
      });
      if (result?.data?.status) {
        success(T("Your wallet address has been edited successfully."));
        if (!props.isWithdraw) {
          props?.onSubmit?.();
        } else {
          props?.onSubmit?.(values.name, values.address);
        }
      } else {
        if (result?.data?.code === 4002) {
          setAvailable(false);
          setErrors([
            {
              key: "address",
              value: T(
                result?.data?.message ??
                  "Existed address. Please enter another address."
              ),
            },
          ]);
        } else if (result?.data?.code === 4001) {
          setAvailable(false);
          setErrors([
            {
              key: "name",
              value: T(
                result?.data?.message ??
                  "Existed name. Please enter another name."
              ),
            },
          ]);
        } else {
          setAvailable(false);
          error(
            T(
              result?.data?.message ||
                "Failed to add your wallet address. Please try again."
            )
          );
        }
      }
    } catch (err) {
      setAvailable(false);
      error(T("Failed to edit your wallet address. Please try again."));
    } finally {
      setLoading(false);
    }
  };
  const onClose = () => {
    props.onClose();
  };
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2 width="600px" onClose={onClose}>
        <ContentWaper>
          <div className="text-black text-center font-medium text-[20px] lg:text-[30px] tracking-[-0.96px]">
            {T(props?.title)}
          </div>
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <Form
                form={form}
                onFinish={() => {
                  handleSubmit(form.getFieldsValue());
                }}
                onValuesChange={() => onUpdateData()}
              >
                <FormItem
                  {...errorView(errors, "name")}
                  className="no-after address-booking-row"
                  name={"name"}
                  label={T("Name")}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error(T("Name is required!"))
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <FormInput
                    className="input-sot"
                    allowClear={{
                      clearIcon: <CloseIconRounded className={"w-5 h-5"} />,
                    }}
                    onChange={() => {
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "name"),
                            1
                          );
                        })
                      );
                    }}
                    placeholder={T("Please enter name")}
                  />
                </FormItem>
                <div className="relative">
                  <FormItem
                    {...errorView(errors, "address")}
                    className="no-after address-booking-row"
                    name={"address"}
                    label={T("Wallet address")}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.reject(
                              new Error(T("Wallet address is required!"))
                            );
                          }
                          if (!isAddress(value)) {
                            return Promise.reject(
                              new Error(
                                T(
                                  "Invalid address. Please enter another address."
                                )
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <FormInput
                      className="input-sot"
                      ref={inputAddressRef}
                      suffix={
                        !showPaste ? (
                          <>
                            <div
                              onClick={() => handleOnRemove()}
                              className="cursor-pointer text-[14px] bg-white flex justify-center w-[32px]"
                            >
                              <CloseIconRounded className={"w-5 h-5"} />
                            </div>
                          </>
                        ) : (
                          <div className="bg-white px-2">
                            <div
                              className="text-aia-red cursor-pointer text-[14px]"
                              onClick={() => handleOnPaste()}
                            >
                              {T("Paste")}
                            </div>
                          </div>
                        )
                      }
                      onChange={() => {
                        setErrors(
                          produce((draft) => {
                            draft.splice(
                              draft.findIndex((item) => item.key === "address"),
                              1
                            );
                          })
                        );
                      }}
                      placeholder={T("Please enter wallet address")}
                    />
                  </FormItem>
                </div>
              </Form>

              <Divider className="my-[32px] hidden md:block" />
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap md:flex-nowrap justify-center items-center gap-[20px]">
                <FormButton
                  className={"black2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  {props?.btnCancelText ? T(props?.btnCancelText) : T("Cancel")}
                </FormButton>
                <FormButton
                  className={"primary2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    form.submit();
                  }}
                  disabled={loading || !available}
                >
                  {props?.btnOkText ? T(props?.btnOkText) : T("Save")}
                </FormButton>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
